import { ReactNode } from 'react';
import Button from '@creditflowresearch/uilib/Button';
import cn from 'classnames';
import IconArrowDown from '@creditflowresearch/uilib/Icon/IconArrowDown';
import IconArrowUp from '@creditflowresearch/uilib/Icon/IconArrowUp';
import Flex from '@creditflowresearch/uilib/Flex';
import { PanelLink } from '@creditflowresearch/uilib/PanelControl';

import styles from './panelButton.module.scss';

interface IPanelButtonProps {
  label: string,
  badge?: ReactNode,
  isActive?: boolean,
  href?: string,
  'data-panel-open'?: boolean,
  'aria-expanded'?: boolean,
  'aria-controls'?: string,
  'aria-keyshortcuts'?: string,
}

const PanelButton = ({
  label,
  badge,
  isActive = false,
  href,
  'data-panel-open': dataPanelOpen,
  'aria-expanded': ariaExpanded,
  'aria-controls': ariaControls,
  'aria-keyshortcuts': ariaKeyshortcuts,
}: IPanelButtonProps) => {
  const isOpen = isActive || dataPanelOpen;

  const sharedProps = {
    dataTest: `panelButton-${ label }`,
    variant: 'text' as const,
    className: cn(styles.panelButton, { active: isOpen }),
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls,
    'aria-keyshortcuts': ariaKeyshortcuts,
  };

  const trigger = href ? (
    <Button as={ PanelLink } to={ href } { ...sharedProps }>
      { label }
    </Button>
  ) : (
    <Button { ...sharedProps }>
      { label }
    </Button>
  );
  return (
    <Flex
      align="center"
      justify="space-between"
      gap={ { sm: 0, md: 10, xl: 10 } }
      wrap="nowrap"
      className={ styles.panelButtonContainer }
    >
      <Flex align="center" gap={ 10 } wrap="nowrap" className={ styles.buttonGroupContainer }>
        { badge }
        { trigger }
      </Flex>
      { isOpen
        ? <IconArrowUp className={ styles.panelControl } />
        : <IconArrowDown className={ styles.panelControl } /> }
    </Flex>
  );
};

export default PanelButton;
